<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="-5 -5 55 55"
    height="65px"
    width="65px"
    :style="'fill:' + color"
  >
    <title>TOILET ICON</title>
    <rect style="fill: #fff" width="55" height="50" rx="7.74"></rect>
    <path
      style="fill: #010101"
      d="M27.35,28.35V43.21c0,.13,0,.17-.1.17-.52,0-1,0-1.54,0-.07,0-.09,0-.09-.14V13.44c0-.11,0-.15.09-.15.51,0,1,0,1.54,0,.09,0,.1,0,.1.16Z"
    ></path>
    <path
      style="fill: #e4087f"
      d="M11.2,43.59l-.34-.13a1.4,1.4,0,0,1-.81-1.38c0-1.7,0-3.39,0-5.09s0-3.45,0-5.17c0-.14,0-.18-.18-.18H6.51c-.15,0-.19,0-.14-.18Q8,25.64,9.69,19.81c.21-.73.42-1.47.64-2.22H9.76c-.1,0-.1.07-.11.13-.3,1-.59,2-.88,3-.47,1.59-.92,3.18-1.39,4.77a1.44,1.44,0,0,1-.83,1,1.25,1.25,0,0,1-1.7-1.1,2.07,2.07,0,0,1,.09-.7c.86-2.86,1.7-5.74,2.6-8.59a4,4,0,0,1,3.11-2.78,2.78,2.78,0,0,1,.58,0c1.41,0,2.83,0,4.24,0a3.8,3.8,0,0,1,2.8,1.33,5.41,5.41,0,0,1,1.17,2.3c.76,2.57,1.54,5.13,2.31,7.69a1.78,1.78,0,0,1,.06,1.07,1.24,1.24,0,0,1-1.09.93A1.19,1.19,0,0,1,19.55,26a3.76,3.76,0,0,1-.38-1.08c-.7-2.39-1.39-4.79-2.09-7.18,0-.12-.07-.17-.2-.15a2.94,2.94,0,0,1-.42,0c-.14,0-.15,0-.12.16.45,1.52.89,3.05,1.34,4.57.89,3.08,1.79,6.15,2.68,9.23a.46.46,0,0,1,0,.09H16.75c-.15,0-.18,0-.18.18,0,3.45,0,6.91,0,10.36a1.32,1.32,0,0,1-.78,1.29c-.12.05-.25.08-.38.12h-.5a1.33,1.33,0,0,1-1.19-1.44V32c0-.25,0-.26-.25-.26-.52,0-.47-.06-.47.47v9.91a1.53,1.53,0,0,1-.47,1.19,1.24,1.24,0,0,1-.75.32Z"
    ></path>
    <path style="fill: #e4087f" d="M13.35,6.41a3,3,0,1,1-3,3A3,3,0,0,1,13.35,6.41Z"></path>
    <path
      style="fill: #299ed9"
      d="M45.15,26.92c-.06,0,0,.1-.06.14a1.29,1.29,0,0,1-1.48.91,1.26,1.26,0,0,1-1.07-1.25v-.26q0-4.11,0-8.22c0-.15,0-.21-.19-.19s-.34-.06-.43,0,0,.28,0,.42v23a2,2,0,0,1-.33,1.29,1.8,1.8,0,0,1-3.17-.73,2.83,2.83,0,0,1,0-.58V28.13c0-.17,0-.23-.21-.22-.34,0-.34,0-.34.35v13.3a1.88,1.88,0,0,1-.61,1.55,1.72,1.72,0,0,1-1.84.27,1.55,1.55,0,0,1-1-1.43,3.39,3.39,0,0,1,0-.45V18.27c0-.18,0-.23-.22-.22-.42,0-.42,0-.42.43v8.06a1.37,1.37,0,0,1-.46,1.13,1.28,1.28,0,0,1-1.41.19,1.17,1.17,0,0,1-.74-1.15V17.42a4.47,4.47,0,0,1,0-.73,3.93,3.93,0,0,1,3.1-3.34,4.41,4.41,0,0,1,.81,0c2,0,4,0,6.05,0a4,4,0,0,1,4,3.56.05.05,0,0,0,0,0Z"
    ></path>
    <path style="fill: #299ed9" d="M38.12,6.41a3,3,0,1,1-3,3A3,3,0,0,1,38.12,6.41Z"></path>
  </svg>
</template>

<script>
export default {
  props: ["seatNo", "color", "pointer"],
  data() {
    return {};
  },
  methods: {
    clickSeat() {
      console.log("Emit Click Seat");
      this.$emit("clickSeat");
    }
  }
};
</script>
